import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { AuthUser } from '../../auth/model/user-auth.model';
import { LocalStorageService } from '../../shared/services/index.service';
import { ActivatedRouteSnapshot, NavigationEnd, Params, Router } from '@angular/router';
import { BANK_TOKEN } from '../../shared/constants';
import { OTP_TOKEN } from '../../shared/services/otp/otp.constants';
import { AuthData } from '@tesla/ng-auth';
import { LanguageService } from '../services/language.service';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { AppConstants, AppSettings } from '../../app.settings';
import { MatomoTracker } from '@ngx-matomo/tracker';
import { TranslateLanguage } from 'app/profile/models/supplier.model';
import { Store, select } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/app.actions';
import { SelectCurrentUser } from 'app/profile/store/app.selector';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() user: AuthUser;
    @Output() navOpen = new EventEmitter();
    displayName = '';
    userName = '';
    supplierCode: '';
    isMenuOpen: Boolean = false;
    private _isSupplierTicketingEnabled = false;
    @Input() set isSupplierTicketingEnabled(val) {
        this._isSupplierTicketingEnabled = val;
    }
    get isSupplierTicketingEnabled() {
        return this._isSupplierTicketingEnabled;
    }
    toDoTaskCount: number;
    get languages(): TranslateLanguage[] {
        return this.languageService.getTranslateLangues();
    }

    constructor(
        private authData: AuthData,
        private localStorageService: LocalStorageService,
        private router: Router,
        private config: AppSettings,
        private languageService: LanguageService,
        private supplierTaskService: SupplierTaskService,
        private appConstants: AppConstants,
        private tracker: MatomoTracker,
        private store: Store<SupplierState>,
    ) {
        this.store.dispatch(new GetSupplierProfileCurrentUser());
    }

    ngOnInit() {
        const userInfo = this.authData.getUserInfo();
        this.displayName = userInfo?.display_name;
        const isTeslaUser = userInfo?.is_employee;

        if (isTeslaUser == false) {
            this.store.pipe(select(SelectCurrentUser)).subscribe((res) => {
                this.displayName = `${res?.supplierContact?.firstName} ${res?.supplierContact?.lastName}`;
            });
        }

        if (this.authData.isTokenActive()) {
            this.tracker.setUserId(userInfo.email);
        }

        /* this subscription will fire always when the url changes */
        this.router.events.subscribe((val) => {
            /* the router will fire multiple events */
            /* we only want to react if it's the final active route */
            if (val instanceof NavigationEnd) {
                var snapshot = this.router.routerState.snapshot.root;
                var params = this.collectParams(snapshot);
                this.supplierCode = params['code'];
            }
        });

        // Get the count of supplier to do tasks
        if (this.displayName && !isTeslaUser) {
            this.supplierTaskService.getToDoTaskCount().subscribe((taskCount) => {
                this.toDoTaskCount = taskCount;
            });
        }
    }

    get baseAppUrl(): string {
        return this.appConstants.PUBLIC_URL;
    }

    collectParams(root: ActivatedRouteSnapshot): Params {
        var params: Params = {};
        (function mergeParamsFromSnapshot(snapshot: ActivatedRouteSnapshot) {
            Object.assign(params, snapshot.params);
            snapshot.children.forEach(mergeParamsFromSnapshot);
        })(root);
        return params;
    }

    redirect() {
        window.open(this.config.SupplierPortalUrl, '_self');
    }

    navigateToTasks() {
        window.open(`${this.config.SRM_UI_URL}tasks`, '_blank');
    }

    onViewMyTickets() {
        window.open(`${this.config.SRM_UI_URL}tickets`, '_blank');
    }

    logout() {
        this.localStorageService.deleteFromStorage(OTP_TOKEN);
        this.localStorageService.deleteFromStorage('PCFPopUp');
        this.localStorageService.deleteFromStorage('ttp-locale');
        this.localStorageService.deleteFromStorage('Profile-Culture');
        this.localStorageService.deleteFromStorage(`${BANK_TOKEN}:${this.supplierCode}`);
        this.router.navigateByUrl('/auth/logout');
    }

    get currentLocale() {
        return this.languageService.getSelectedLanguage();
    }

    onLanguageSelect(event) {
        this.languageService.changeLanguage(event);
    }
}
